// extracted by mini-css-extract-plugin
export default {"link":"IQ-z","disabled":"JQ-z"};